import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './ProgressBar.module.scss';

const ProgressBar = ({ starting, duration }) => {
  return (
    <div className={styles.well}>
      <div
        style={{ animationDuration: `${duration}ms` }}
        className={[starting ? styles.progressStarted : '', styles.progress].join(' ')}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  starting: PropTypes.bool.isRequired,
  duration: PropTypes.number.isRequired,
};

export default ProgressBar;
